import { initUpgradeSubscriptionForm } from './upgrade'
import { initCancelSubscription } from './cancel'
import { gettext, modals, notifications } from '@bikemap/js/services'
import { defaultGet } from '@bikemap/js/utility'

function initBillingDetails() {
    const link = document.getElementById('billing-details-link')
    if (link) {
        link.addEventListener('click', e => {
            e.preventDefault()
            modals.show('billing-details', {
                title: gettext('Billing Details'),
                body: '<div class="loading-spinner spinner-blue"></div>',
                fullscreen: true,
                onShow: (openEvent, modal) => {
                    defaultGet(e.target.dataset.href + '?modal=1')
                        .then(res => modal.patch({ body: '<div class="text-left">' + res.html + '</div>' }))
                        .catch(res => notifications.error(res.statusText))
                },
            })
        })
    }
}

// This function is copy-pasted from user-profile.js
function initReActivateForm() {
    if ($('#reactivate-subscription-form').length > 0) {
        $('#reactivate-subscription-form').on('submit', function (ev) {
            var form = $('#reactivate-subscription-form')
            $('#reactivate-subscription-form button').prop('disabled', true)
            $('#reactivate-subscription-form button').addClass('loading-spinner')
            ev.preventDefault()
            $.ajax({
                method: form.attr('method'),
                url: form.attr('action'),
                data: { activateSubscription: true },
                headers: { 'X-CSRFToken': $.outdoorish.readCookie('csrftoken') },
                complete: $.outdoorish.forms.handleAjaxFormErrors,
                error: function () {
                    $('#reactivate-subscription-form button').prop('disabled', false)
                    $('#reactivate-subscription-form button').removeClass(
                        'loading-spinner'
                    )
                },
            })
        })
    }
}

export function initSubscriptionTab() {
    initUpgradeSubscriptionForm()
    initCancelSubscription()
    initBillingDetails()
    initReActivateForm()
}
